$(function () {
  $('.image-keywords').select2({
    tags: true,
    tokenSeparators: [',', ';']
  });
});

$(document).on("turbolinks:before-cache", function() {
  $(".image-keywords").select2('destroy');
})